export const ModalStoreModule = {
  namespaced: true,
  state: () => ({
    modals: {},
  }),
  mutations: {
    SET_MODALS(state, val) {
      state.modals = val;
    },
  },
  actions: {
    addModal({ state, commit }, { name, value }) {
      commit('SET_MODALS', { ...(state.modals), [name]: value });
    },
    removeModal({ state, commit }, name) {
      const newState = { ...(state.modals) };
      delete newState[name];
      commit('SET_MODALS', newState);
    },
    openModal({ state, commit }, name) {
      commit('SET_MODALS', { ...(state.modals), [name]: true });
    },
    closeModal({ state, commit }, name) {
      commit('SET_MODALS', { ...(state.modals), [name]: false });
    },
  },
};
